var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c(_vm.component,{tag:"component",attrs:{"preview":_vm.data}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }